"use client";

import lottie, { AnimationItem } from "lottie-web";
import { SetStateAction, useCallback, useEffect, useState } from "react";
import { defaultLottieOptions } from "utils/lottie";

const useStatefulNode = (setStateFn: (value: SetStateAction<HTMLDivElement>) => void) => {
  return useCallback(
    (node) => {
      if (node !== null) {
        setStateFn(node);
      }
    },
    [setStateFn],
  );
};

export const useLottie = (
  path: string,
  viewBox?: string,
  alt?: string,
  speed = 1,
  mirror = false,
) => {
  const [animContainer, setAnimContainer] = useState<HTMLDivElement>(null);

  const ref = useStatefulNode(setAnimContainer);

  useEffect(() => {
    let animation: AnimationItem;

    if (!animation) {
      animation = lottie.loadAnimation({
        ...defaultLottieOptions,
        container: animContainer,
        path,
        rendererSettings: viewBox
          ? {
              viewBoxSize: viewBox,
            }
          : null,
      });
    }

    animation.setSpeed(speed);

    if (animContainer && mirror) {
      animContainer.style.transform = "scaleX(-1)";
    }

    return () => {
      animation?.destroy();
    };
  }, [animContainer, path, viewBox, alt, speed, mirror]);

  return ref;
};
